module.exports = __webpack_public_path__ + "static/media/add.a29d33ef.svg";